import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'

// Selectors
import { selectValuationBounds } from '../../../../../store/selectors/home'
import { selectShouldDisplayWhatSellFor } from '../../../../../store/selectors/display'

// Components
import { Panel, Text, Format } from '../../../..'
import Question from '../../../Questions/QuestionSingleContainer'
import { InstantOfferButton } from '../../../AvmModule/InstantOffer/InstantOfferButton'

// Constants
import { CUSTOMER_MESSAGES } from '../../../../../constants/customerMessages'

// Styles
import styles from './WhatSellFor.module.scss'

// Types
import { RootState } from '../../../../../types/rootState'

const MSG = defineMessages({
  whatCouldYouSellFor: {
    id: 'ShouldYouSell.WhatSellFor.title',
    defaultMessage: 'What could you sell for?'
  },
  beAbleToSellFor: {
    id: 'ShouldYouSell.WhatSellFor.description',
    defaultMessage: 'Based on recent nearby sales, you might be able to sell for'
  }
})

interface WhatSellForProps {
  className?: string
}

export const WhatSellFor = ({ className }: WhatSellForProps) => {
  const intl = useIntl()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const bounds = useSelector<RootState, any>(selectValuationBounds) || {}
  const display = useSelector(selectShouldDisplayWhatSellFor)

  return (
    <Panel data-qa='what-sell-for' className={classnames(styles.panel, !display && styles.hide, className)}>
      <Text upperspaced variant='neutralCool' variantCount='600' size='s' className={styles.title}>
        {intl.formatMessage(MSG.whatCouldYouSellFor)}
      </Text>
      <Text size='m' variant='neutralCool' variantCount='900' className={styles.description}>
        {intl.formatMessage(MSG.beAbleToSellFor)}
      </Text>

      <Text data-qa='what-sell-for-low-high-range' size='xl' variant='primary' className={styles.numbers}>
        <Format.Currency abbreviate value={bounds?.low} />
        {' - '}
        <Format.Currency abbreviate value={bounds?.high} />
      </Text>

      <InstantOfferButton className={styles.instantOfferBtn} />

      <Question
        questionTopic={CUSTOMER_MESSAGES.WHAT_TO_SELL_FOR.topic}
        questionTopicKey={CUSTOMER_MESSAGES.WHAT_TO_SELL_FOR.topicKey}
        placeholder={intl.formatMessage(CUSTOMER_MESSAGES.WHAT_TO_SELL_FOR.message)}
      />
    </Panel>
  )
}
